import React from "react"
import { useContext, useEffect, useState, useRef } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import '../../assets/css/style1.css'
import { useNavigate } from 'react-router-dom';
import { GetDictionary } from '../../utilities/CommonFunctions';
import { useSelector } from 'react-redux';
import CommonService from "../../services/common.service";
import {
  GETPermission_url
} from "../../services/end-url";
import "../../assets/css/psidebar.css";
import parse, { domToReact } from "html-react-parser";

const UserSidebar = (props, { children }) => {
  const [dic_lng, setdic_lng] = useState({});
  const activemenuRef = useRef("");
  const navigate = useNavigate();
  const { user: users } = useSelector((state) => state.auth);

  const [Resource, setResource] = useState({});
  const [activemenu, setactivemenu] = useState(localStorage.getItem('activemenu'));
  const [Setmenu, setSetmenu] = useState(false);

  const [sub_menu_html, set_sub_menu_html] = useState([]);

  useEffect(() => {

    // setActiveMenu()

    async function callfunc() {
      let d = await GetDictionary("1,3,5,6,7,8,9,12,14,13,15,16,17,18,22,23,24,26,28,29,47");
      setdic_lng(d);
    }
    callfunc()

    //access metrix
    // async function AccessMetrix() {
    //   let param = {
    //     "role_id": 0,
    //     "user_id": user.userid,
    //     "user_type": localStorage.getItem("user_type")
    //   }
    //   await CommonService.create(GETPermission_url, param)
    //     .then(response => {
    //       let res = {};
    //       globalThis.config.Settings.ApiConfiguration.Permissions = response.data.Permissions;
    //       response.data.Resources.forEach(element => {
    //         res["menu" + element.resource_id] = "resource-" + element.resource_id
    //       });
    //       setResource(res);
    //     }).catch(e => {
    //       console.log(e);
    //     });
    // };
    // AccessMetrix();
    let get_resourses = JSON.parse(localStorage.getItem("accessmatrix")).Resources;
    let res = {};
    get_resourses.forEach(element => {
      res["menu" + element.resource_id] = "resource-" + element.resource_id
    });
    setResource(res);

    if (location.pathname == '/DFODashboard') {
      props.handleViewSidebar();
    }

    //access metrix
  }, [])
  useEffect(() => {
    setActiveMenu()
    setSetmenu(true)
  })

  // function setActiveMenu() {
  const setActiveMenu = async () => {

    /* Dashboard */
    // window.location.href.includes("/Dashboard") == true ? document.getElementById('li_Dashboard').classList.add('active') :
    //   document.getElementById('li_Dashboard').classList.remove('active');
    /* Dashboard */

    //  /* TOF */
    let activemenu = '';
    // window.location.href.includes("/TOF_Dashboard_staff") == true ? document.getElementById('li_TOF').classList.add('active') :
    //   document.getElementById('li_TOF').classList.remove('active');

    // window.location.href.includes("TOF_Dashboard_staff") == true ? activemenu = "13" : ''
    // window.location.href.includes("TOF_Dashboard") == true ? activemenu = "13" : ''
    // window.location.href.includes("User_Details") == true ? activemenu = "13" : ''
    // window.location.href.includes("/Applications") == true ? activemenu = "13" : ''
    // window.location.href.includes("/ApplicationsTF") == true ? activemenu = "13" : ''
    // window.location.href.includes("/ApplicationReg") == true ? activemenu = "13" : ''
    // window.location.href.includes("/TreeFelling") == true ? activemenu = "13" : ''
    //  {/* TOF */}

    /* DeforestationWatch */
    window.location.href.includes("/GFWETL") == true ? document.getElementById('li_DeforestationWatch').classList.add('active') :
      document.getElementById('li_DeforestationWatch').classList.remove('active');
    /* DeforestationWatch */

    //  {/* Vehicle */}
    // window.location.href.includes("/Vehicle") == true ? document.getElementById('li_Vehicle').classList.add('active') :
    //   document.getElementById('li_Vehicle').classList.remove('active');

    // window.location.href.includes("/Vehicle") == true ? activemenu = "15" : ''
    // window.location.href.includes("/VehicleAllotment") == true ? activemenu = "15" : ''
    // window.location.href.includes("/VehicleMaintainance") == true ? activemenu = "15" : ''
    //  {/* Vehicle */}

    //  {/* Nursery */}
    // window.location.href.includes("/Nursery") == true ? document.getElementById('li_Nursery').classList.add('active') :
    //   document.getElementById('li_Nursery').classList.remove('active');
    // window.location.href.includes("/Nursery") == true ? activemenu = "49" : ''
    // window.location.href.includes("/WorkProgress") == true ? activemenu = "49" : ''
    // window.location.href.includes("/StockDetails") == true ? activemenu = "49" : ''
    // window.location.href.includes("/NurseryTarget") == true ? activemenu = "49" : ''
    //  /* Nursery */

    /* Admin Settings */
    window.location.href.includes("/BilingualSettings") == true ? document.getElementById('li_AdminSettings').classList.add('active') :
      document.getElementById('li_AdminSettings').classList.remove('active');

    window.location.href.includes("/BilingualSettings") == true ? activemenu = "18" : ''
    window.location.href.includes("/LookUpSettings") == true ? activemenu = "18" : ''
    // window.location.href.includes("/AdminRoles") == true ? activemenu = "18" : ''
    window.location.href.endsWith("/User") == true ? activemenu = "18" : ''
    window.location.href.endsWith("/UserRole_Mapping") == true ? activemenu = "18" : ''
    window.location.href.endsWith("/UserRoleMatrix") == true ? activemenu = "18" : ''
    window.location.href.endsWith("/Application") == true ? activemenu = "18" : ''
    /* Admin Settings */
    /* HRMS */
    window.location.href.includes("/HRMS_Dashboard") == true ? document.getElementById('li_HRMS').classList.add('active') :
      document.getElementById('li_HRMS').classList.remove('active');

    window.location.href.includes("/HRMS_Dashboard") == true ? activemenu = "19" : ''
    window.location.href.includes("/DEODashboard") == true ? activemenu = "19" : ''
    window.location.href.includes("/Wing") == true ? activemenu = "19" : ''
    window.location.href.includes("/ManageOffice") == true ? activemenu = "19" : ''
    window.location.href.includes("/Employee") == true ? activemenu = "19" : ''
    window.location.href.includes("/EmployeeDetails") == true ? activemenu = "19" : ''
    window.location.href.includes("/ManageTransfer") == true ? activemenu = "19" : ''
    window.location.href.includes("/EmployeeSuspension") == true ? activemenu = "19" : ''
    window.location.href.includes("/EmployeeSeparation") == true ? activemenu = "19" : ''
    window.location.href.includes("/ApproveEmployee") == true ? activemenu = "19" : ''
    window.location.href.includes("/Leave_list") == true ? activemenu = "19" : ''

    /* HRMS */
    /* Training */
    // window.location.href.includes("/Training") == true ? document.getElementById('li_Training').classList.add('active') :
    //   document.getElementById('li_Training').classList.remove('active');

    // window.location.href.includes("/Training") == true ? activemenu = "12" : ''
    // window.location.href.includes("/TrainingSyllabus") == true ? activemenu = "12" : ''
    // window.location.href.includes("/TrainingBatch") == true ? activemenu = "12" : ''
    // window.location.href.includes("/Facilitators") == true ? activemenu = "12" : ''
    // window.location.href.includes("/TrainingCalender") == true ? activemenu = "12" : ''
    // window.location.href.includes("/TrainingFeedback") == true ? activemenu = "12" : ''
    /* Training */
    /* Offence */
    // window.location.href.includes("/offence") == true ? document.getElementById('li_offence').classList.add('active') :
    //   document.getElementById('li_offence').classList.remove('active');

    // window.location.href.includes("/OffenceAdmin") == true ? activemenu = "20" : ''
    // window.location.href.includes("/OffenderProfiler") == true ? activemenu = "20" : ''
    // window.location.href.includes("/CheckPost") == true ? activemenu = "20" : ''


    /* Offence */
    /* FRA */

    // window.location.href.includes("/FRA") == true ? document.getElementById('li_FRA').classList.add('active') :
    //   document.getElementById('li_FRA').classList.remove('active');
    // window.location.href.includes("/FRA") == true ? activemenu = "21" : ''
    // window.location.href.includes("/FRAStatus") == true ? activemenu = "21" : ''
    /* FRA */

    /* Wildlife Management */

    window.location.href.includes("/Humanwildlifeconflict") == true ? document.getElementById('li_WildlifeManagement').classList.add('active') :
      document.getElementById('li_WildlifeManagement').classList.remove('active');
    window.location.href.includes("/WildlifeDashboard") == true ? activemenu = "22" : ''
    window.location.href.includes("/Humanwildlifeconflict") == true ? activemenu = "22" : ''
    window.location.href.includes("/WildlifeCompensation") == true ? activemenu = "22" : ''
    window.location.href.includes("/HWCApplications") == true ? activemenu = "22" : ''
    window.location.href.includes("/Census") == true ? activemenu = "22" : ''
    window.location.href.includes("/Poaching") == true ? activemenu = "22" : ''
    window.location.href.includes("/Sighting") == true ? activemenu = "22" : ''
    window.location.href.includes("/wild-life-population") == true ? activemenu = "22" : ''
    window.location.href.includes("/wildlife-mortality") == true ? activemenu = "22" : ''
    window.location.href.includes("/HuamanDeah") == true ? activemenu = "22" : ''
    /* Wildlife Management */

    /*  DigitalLibrary */
    // window.location.href.includes("/DigitalLibrary") == true ? document.getElementById('li_DigitalLibrary').classList.add('active') :
    //   document.getElementById('li_DigitalLibrary').classList.remove('active');
    // window.location.href.includes("/DigitalLibrary") == true ? activemenu = "58" : ''
    /*  DigitalLibrary */

    /*  Ecotourism */
    // window.location.href.includes("/Ecotourism") == true ? activemenu = "60" : ''
    // window.location.href.includes("/DestinationList") == true ? activemenu = "60" : ''
    /*  Ecotourism */

    /*  Encroachment */
    // window.location.href.includes("/RegisterEncroachment") == true ? document.getElementById('li_Encroachment').classList.add('active') :
    //   document.getElementById('li_Encroachment').classList.remove('active');

    // window.location.href.includes("/RegisterEncroachment") == true ? activemenu = "62" : ''
    // window.location.href.includes("/EncroachmentAdmin") == true ? activemenu = "62" : ''
    /*  Encroachment */

    /*  AssetManagement */
    // window.location.href.includes("/AssetManagement") == true ? document.getElementById('li_AssetManagement').classList.add('active') :
    //   document.getElementById('li_AssetManagement').classList.remove('active');

    // window.location.href.includes("/AssetManagement") == true ? activemenu = "65" : ''
    /*  AssetManagement */

    // NewsSetting
    window.location.href.includes("/NewsSettings") == true ? activemenu = "67" : ''
    //Event
    window.location.href.includes("/EventSetting") == true ? activemenu = "68" : ''

    // window.location.href.includes("/Section11Dashboard") == true ? activemenu = "22" : ''

    /*courtecase */
    // window.location.href.includes("/CourtCase") == true ? document.getElementById('li_courtCase').classList.add('active') :
    //   document.getElementById('li_courtCase').classList.remove('active');

    // window.location.href.includes("/CourtCase") == true ? activemenu = "105" : ''
    /*courtecase */

    /*Revenue */
    // window.location.href.includes("/Revenue") == true ? document.getElementById('li_Revenue').classList.add('active') :
    //   document.getElementById('li_Revenue').classList.remove('active');
    // window.location.href.includes("/Revenue") == true ? activemenu = "138" : ''
    /*Revenue */

    localStorage.setItem('activemenu', activemenu);
    setactivemenu(activemenu)
  }

  const { user: currentUser, isLoggedIn } = useSelector((state) => state.auth);


  const [isSidebarClosed, setSidebarClosed] = useState(true);
  const [menuState, setMenuState] = useState({
    Tree_Out_Forest: false,
    Vehicle_Management: false,
    Nursery: false,
    Admin_Settings: false,
    HRMS: false,
    Training: false,
    Offence: false,
    FRA: false,
    Wildlife: false,
    Digital_Library: false,
    Encroachment: false,
    Asset_Management: false,
    Protection_And_Patrolling: false,
    CourtCase: false,
    Revenue: false
  });

  // Toggle sidebar open/close state
  const toggleSidebar = () => {
    setSidebarClosed(!isSidebarClosed);
  };

  function link_click() {
    alert('Hii');
  };

  // Toggle individual menu open/close state
  const toggleMenu = (menu) => {

    setMenuState((prevState) => ({
      Tree_Out_Forest: false,
      Vehicle_Management: false,
      Nursery: false,
      Admin_Settings: false,
      HRMS: false,
      Training: false,
      Offence: false,
      FRA: false,
      Wildlife: false,
      Digital_Library: false,
      Encroachment: false,
      Asset_Management: false,
      Protection_And_Patrolling: false,
      CourtCase: false,
      Revenue: false
    }));

    setMenuState((prevState) => ({
      ...prevState,
      [menu]: !prevState[menu],
    }));

  };

  useEffect(() => {
    const sidebar = document.querySelector(".sidebar");
    const sidebarBtn = document.querySelector(".bx-chevron-right");
    const navLinks = document.querySelectorAll(".nav-links-scroll li");
    const floatingSubmenu = document.getElementById("floatingSubmenu");

    let hideTimeout = null;

    sidebarBtn.onclick = () => {
      sidebar.classList.toggle("close");
      floatingSubmenu.style.display = "none";
      document.querySelectorAll(".sub-menu").forEach(sm => sm.style.display = "none");
    };

    navLinks.forEach(li => {
      const link = li.querySelector("a");
      const subMenu = li.querySelector(".sub-menu");

      link.addEventListener("click", (e) => {
        if (!sidebar.classList.contains("close") && subMenu) {
          e.preventDefault();
          const isOpen = subMenu.style.display === "block";
          document.querySelectorAll(".sub-menu").forEach(sm => sm.style.display = "none");
          subMenu.style.display = isOpen ? "none" : "block";
        }
      });

      li.addEventListener("mouseenter", (e) => {

        if (sidebar.classList.contains("close") && subMenu) {
          clearTimeout(hideTimeout);
          let submenuHTML = "";
          subMenu.querySelectorAll("a").forEach(a_tag => {
            try {
              submenuHTML += `<a class="menu_link ${a_tag.attributes["hoverClass"].value}" url=${a_tag.attributes["url"].value} >${a_tag.textContent}</a>`;
            }
            catch (ex) {
              console.log(ex);
            }
          });
          set_sub_menu_html(submenuHTML);
          const buttons = htmlRef.current.querySelectorAll('.menu_link'); // <-- class selector       

          buttons.forEach(button => {
            button.addEventListener('click', menu_click);
          });

          // // Cleanup
          // return () => {
          //   buttons.forEach(button => {
          //     button.removeEventListener('click', menu_click);
          //   });
          // };


          //floatingSubmenu.innerHTML = submenuHTML;

          const rect = li.getBoundingClientRect();
          floatingSubmenu.style.top = `${rect.top + window.scrollY}px`;
          floatingSubmenu.style.left = `${sidebar.offsetWidth + 1}px`;
          floatingSubmenu.style.display = "block";
        }
      });

      li.addEventListener("mouseleave", () => {
        if (sidebar.classList.contains("close")) {
          hideTimeout = setTimeout(() => {
            floatingSubmenu.style.display = "none";
          }, 300); // small delay
        }
      });
    });


    // Protect floating submenu
    floatingSubmenu.addEventListener("mouseenter", () => {
      clearTimeout(hideTimeout);
      floatingSubmenu.style.display = "block";
    });
    floatingSubmenu.addEventListener("mouseleave", () => {
      hideTimeout = setTimeout(() => {
        floatingSubmenu.style.display = "none";
      }, 300); // small delay
    });

  }, []);
  const menu_click = () => {

    navigate(event.target.attributes["url"].value);

    // let link_text = event.target.text;
    // if (link_text == 'Register Offence') {
    //   navigate(location.pathname.includes('/as') ?
    //     globalThis.config.Settings.ApiConfiguration.BaseURL + "/offence/as" :
    //     globalThis.config.Settings.ApiConfiguration.BaseURL + "/offence");
    // }
    // else if (link_text == 'Offender Profiler') {
    //   navigate(location.pathname.includes('/as') ?
    //     globalThis.config.Settings.ApiConfiguration.BaseURL + "/OffenderProfiler/as" :
    //     globalThis.config.Settings.ApiConfiguration.BaseURL + "/OffenderProfiler");
    // }
  };
  // const floating_submenu = (li) => {
  //   const sidebar = document.querySelector(".sidebar");
  //   const sidebarBtn = document.querySelector(".bx-menu");
  //   const navLinks = document.querySelectorAll(".nav-links-scroll li");
  //   const floatingSubmenu = document.getElementById("floatingSubmenu");

  //    let hideTimeout = null;

  //   if (sidebar.classList.contains("close") && subMenu) {
  //     clearTimeout(hideTimeout);
  //     let submenuHTML = "";
  //     subMenu.querySelectorAll("a").forEach(a_tag => {
  //       submenuHTML += `<a href="#" >${a_tag.textContent}</a>`;
  //     });
  //     floatingSubmenu.innerHTML = submenuHTML;

  //     const rect = li.getBoundingClientRect();
  //     floatingSubmenu.style.top = `${rect.top + window.scrollY}px`;
  //     floatingSubmenu.style.left = `${sidebar.offsetWidth + 1}px`;
  //     floatingSubmenu.style.display = "block";
  //   }
  // }; 
  const htmlRef = useRef();
  useEffect(() => {
    // const buttons = htmlRef.current.querySelectorAll('.myLink'); // <-- class selector

    // const handleClick = () => {
    //   console.log('Button clicked!');
    // };

    // buttons.forEach(button => {
    //   button.addEventListener('click', handleClick);
    // });

    // // Cleanup
    // return () => {
    //   buttons.forEach(button => {
    //     button.removeEventListener('click', handleClick);
    //   });
    // };
  }, []);

  return (

    <>
      {/* New Side Bar */}
      <>
        <div id="menu_sidebar" className={`sidebar ${isSidebarClosed ? 'close' : ''}`}>
          <div className="nav-links">
            <ul className="nav-links-scroll">
              {/* Dashboard */}
              {/* <li id='li_Dashboard' className={Resource.menu160 == 'resource-160' ? "nav-item" : "nav-item d-none"}>
                <div className="iocn-link">
                  <a href="javascript:void(0)" onClick={() => {
                    location.pathname.includes('/as') ? navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard/as") : navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard");
                    props.handleViewSidebar();
                  }}>
                    <i className="dashboard_1" />
                    <span className="link_name">{dic_lng["Dashboard"]}</span>
                  </a>
                </div>
                <ul className="sub-menu blank">
                  <li>
                    <a hoverClass=""
                    url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard"}
                    className="link_name" onClick={() => {
                    location.pathname.includes('/as') ? navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard/as") : navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Dashboard");
                    props.handleViewSidebar();
                    }}>
                      {dic_lng["Dashboard"]}
                    </a>
                  </li>
                </ul>
              </li> */}
              {/* Dashboard */}
              {/* Admin Settings */}
              <li id='li_AdminSettings' className={Resource.menu1 == 'resource-1' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="admin-setting" />
                    <span className="link_name">{dic_lng["Admin_Settings"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.Admin_Settings ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('Admin_Settings')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.Admin_Settings ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Admin_Settings"]}
                    </a>
                  </li>
                  <li className={Resource.menu2 == 'resource-2' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu2 == 'resource-2' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/BilingualSettings/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/BilingualSettings"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/BilingualSettings/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/BilingualSettings")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Dictionary"]}</a>
                  </li>
                  <li className={Resource.menu3 == 'resource-3' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu3 == 'resource-3' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ClassifierSettings/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ClassifierSettings"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ClassifierSettings/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ClassifierSettings")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Look_Up_Settings"]}</a>
                  </li>
                  <li className={Resource.menu39 == 'resource-39' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu39 == 'resource-39' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{globalThis.config.Settings.Locale == 'en' ? "Role" : "ভূমিকা"}</a>
                  </li>
                  <li className={Resource.menu40 == 'resource-40' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu40 == 'resource-40' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/User/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/User"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/User/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/User")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{globalThis.config.Settings.Locale == 'en' ? "User" : "মেপিং"}</a>
                  </li>
                  <li className={Resource.menu41 == 'resource-41' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu41 == 'resource-41' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRole_Mapping/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRole_Mapping"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRole_Mapping/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRole_Mapping")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{globalThis.config.Settings.Locale == 'en' ? "User Role Mapping" : "ব্যৱহাৰকাৰীৰ ভূমিকা মেপিং"}</a>
                  </li>
                  <li className={Resource.menu42 == 'resource-42' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu42 == 'resource-42' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRoleMatrix"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AdminRoles/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/UserRoleMatrix")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{globalThis.config.Settings.Locale == 'en' ? "Role Responsibility Matrix" : "ভূমিকা দায়বদ্ধতা মেট্ৰিক্স"}</a>
                  </li>
                  <li className={Resource.menu47 == 'resource-47' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu47 == 'resource-47' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Application/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Application"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Application/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Application")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Admin_App"]}</a>
                  </li>
                  <li className={Resource.menu67 == 'resource-67' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu67 == 'resource-67' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/NewsSettings/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/NewsSettings"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/NewsSettings/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/NewsSettings")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["News_Setting"]}</a>
                  </li>
                  <li className={Resource.menu70 == 'resource-70' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu70 == 'resource-70' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/EventSettings/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/EventSettings"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EventSettings/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EventSettings")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["EventSetting"]}</a>
                  </li>
                  <li>
                    <a url={(location.pathname.includes('/as')) ?
                      globalThis.config.Settings.ApiConfiguration.BaseURL + "/DecimalDegreeConverter/as" :
                      globalThis.config.Settings.ApiConfiguration.BaseURL + "/DecimalDegreeConverter"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/DecimalDegreeConverter/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/DecimalDegreeConverter")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["DMS_to_Decimal_Degrees"]}</a>
                  </li>
                </ul>
              </li>
              {/* Admin Settings */}
              {/* HRMS */}
              <li id='li_HRMS' className={Resource.menu11 == 'resource-11' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="hrms" />
                    <span className="link_name">{dic_lng["HRMS"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.HRMS ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('HRMS')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.HRMS ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["HRMS"]}
                    </a>
                  </li>
                  <li className={Resource.menu44 == 'resource-44' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu44 == 'resource-44' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/HRMS_Dashboard/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/HRMS_Dashboard"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/HRMS_Dashboard/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/HRMS_Dashboard")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Dashboard"]}</a>
                  </li>
                  {/* <li className={Resource.menu46 == 'resource-46' ? "" : "d-none"}>
                    <a url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/DEODashboard/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/DEODashboard"}
                    onClick={() => (location.pathname.includes('/as')) ?
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/DEODashboard/as") :
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/DEODashboard")}>
                    <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["DEODashboard"]}</a>
                  </li> */}
                  {/* <li>
              <a onClick={() => (location.pathname.includes('/as')) ? 
                navigate(globalThis.config.Settings.ApiConfiguration.BaseURL+"/Wing/as") : 
                navigate(globalThis.config.Settings.ApiConfiguration.BaseURL+"/Wing")}>
               <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Wing"]}</a>
              </li> */}
                  {/* <li>
              <a onClick={() => (location.pathname.includes('/as')) ? 
                navigate(globalThis.config.Settings.ApiConfiguration.BaseURL+"/ManageOffice/as") : 
                navigate(globalThis.config.Settings.ApiConfiguration.BaseURL+"/ManageOffice")}>
               <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Manage_Office"]}</a>
              </li> */}
                  <li className={Resource.menu13 == 'resource-13' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu13 == 'resource-13' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Employee/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Employee"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Employee/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Employee")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["EmployeeManagement"]}</a>
                  </li>
                  <li className={Resource.menu104 == 'resource-104' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu104 == 'resource-104' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeDetails/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeDetails"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeDetails/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeDetails")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["MyDetails"]}</a>
                  </li>
                  <li className={Resource.menu137 == 'resource-137' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu137 == 'resource-137' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Leave_list/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Leave_list"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Leave_list/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Leave_list")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Leave"]}</a>
                  </li>
                  <li className={Resource.menu16 == 'resource-16' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu16 == 'resource-16' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ManageTransfer/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ManageTransfer"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ManageTransfer/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ManageTransfer")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Transfer"]}</a>
                  </li>
                  <li className={Resource.menu17 == 'resource-17' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu17 == 'resource-17' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSuspension/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSuspension"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSuspension/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSuspension")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["EmployeeSuspension"]}</a>
                  </li>
                  <li className={Resource.menu43 == 'resource-43' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu43 == 'resource-43' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSeparation/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSeparation"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSeparation/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EmployeeSeparation")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["EmployeeSeparation"]}</a>
                  </li>
                  <li className={Resource.menu136 == "resource-136" ? "" : "d-none"}>
                    <a hoverClass={Resource.menu136 == 'resource-136' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ConfidentialReport/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ConfidentialReport"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ConfidentialReport/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ConfidentialReport")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["annrep"]}</a>
                  </li>
                  <li className={Resource.menu161 == "resource-161" ? "" : "d-none"}>
                    <a hoverClass={Resource.menu161 == 'resource-161' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/RecognitionAppreciation/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/RecognitionAppreciation"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/RecognitionAppreciation/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/RecognitionAppreciation")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["RecognitionAppreciation"]}</a>
                  </li>
                  <li className={Resource.menu162 == 'resource-162' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu162 == 'resource-162' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Reports/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Reports"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Reports/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Reports")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Reports"]}</a>
                  </li>

                  {/* <li className={Resource.menu163 == "resource-163" ? "" : "d-none"}>
                    <a url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/MutualTransfer/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/MutualTransfer"}
                    onClick={() => (location.pathname.includes('/as')) ? navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/MutualTransfer/as") : navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/MutualTransfer")}>
                    <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" /> {dic_lng["MutualTransfer"]}</a>
                  </li> */}
                </ul>
              </li>
              {/* HRMS */}
              {/* Wildlife Management */}
              <li id='li_WildlifeManagement' className={Resource.menu28 == 'resource-28' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="wildlife" />
                    <span className="link_name">{dic_lng["Wildlife"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.Wildlife ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('Wildlife')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.Wildlife ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Wildlife"]}
                    </a>
                  </li>
                  <li className={Resource.menu29 == 'resource-29' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu29 == 'resource-29' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Humanwildlifeconflict/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Humanwildlifeconflict"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Humanwildlifeconflict/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Humanwildlifeconflict")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["hwc_ro"]}</a>
                  </li>
                  <li className={Resource.menu55 == 'resource-55' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu55 == 'resource-55' ? "" : "d-none"} url={(location.pathname.includes('/as')) ?
                      globalThis.config.Settings.ApiConfiguration.BaseURL + "/WildlifeCompensation/as" :
                      globalThis.config.Settings.ApiConfiguration.BaseURL + "/WildlifeCompensation"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/WildlifeCompensation/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/WildlifeCompensation")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["human_wildlife_compensation"]}
                    </a>
                  </li>

                  <li className={Resource.menu169 == 'resource-169' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu169 == 'resource-169' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/HuamanDeah/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/HuamanDeah"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/HuamanDeah/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/HuamanDeah")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Martyr"]}
                    </a>
                  </li>

                  {users.role_id == 3 &&
                    <li>
                      <a hoverClass=""
                        url={(location.pathname.includes('/as')) ?
                          globalThis.config.Settings.ApiConfiguration.BaseURL + "/Section11Dashboard/as" :
                          globalThis.config.Settings.ApiConfiguration.BaseURL + "/Section11Dashboard"}
                        onClick={() => (location.pathname.includes('/as')) ?
                          navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Section11Dashboard/as") :
                          navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Section11Dashboard")}>
                        <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />Section-11 Dashboard</a>
                    </li>
                  }
                </ul>
              </li>
              {/* Wildlife Management */}
              {/* Offence */}
              <li id='li_offence' className={Resource.menu25 == 'resource-25' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="hammer-offence" />
                    <span className="link_name">{dic_lng["Offence"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.Offence ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('Offence')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.Offence ? 'showMenu' : ''}`}>
                  <li className={Resource.menu26 == 'resource-26' ? "" : "d-none"} >
                    <a hoverClass={Resource.menu26 == 'resource-26' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/offence/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/offence"}

                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/offence/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/offence")}
                    >
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Register_Offence"]}</a>
                  </li>
                </ul>
              </li>
              {/* Offence */}
              {/* Deforestation Watch  */}
              <li id='li_DeforestationWatch' className={Resource.menu100 == 'resource-100' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="patrolling" />
                    <span className="link_name">{dic_lng["Protection_And_Patrolling"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.Protection_And_Patrolling ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('Protection_And_Patrolling')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.Protection_And_Patrolling ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Protection_And_Patrolling"]}
                    </a>
                  </li>
                  {/* <li className={Resource.menu101 == 'resource-101' ? "" : "d-none"} >
                    <a hoverClass = {Resource.menu101 == 'resource-101' ? "" : "d-none"}
                    url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL"}
                    onClick={() => (location.pathname.includes('/as')) ?
                      navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL/as") :
                      navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["GWF_Alert"]}</a>
                  </li> */}

                  {/* <li className={Resource.menu101 == 'resource-101' ? "" : "d-none"} >
                    <a hoverClass = {Resource.menu101 == 'resource-101' ? "" : "d-none"}
                    url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL"}
                    onClick={() => (location.pathname.includes('/as')) ?
                      navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL/as") :
                      navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/GFWETL")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["GWF_Alert_download"]}</a>
                  </li> */}
                  <li className={Resource.menu168 == 'resource-168' ? "" : "d-none"} >
                    <a hoverClass={Resource.menu168 == 'resource-168' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertTransformation/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertTransformation"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertTransformation/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertTransformation")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["alertskey"]}</a>
                  </li>
                  {/* alert code start */}
                  <li className={Resource.menu166 == 'resource-166' ? "" : "d-none"} >
                    <a hoverClass={Resource.menu166 == 'resource-166' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Alerts/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Alerts"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Alerts/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Alerts")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Alerts"]}</a>
                  </li>
                  {/* alert code end */}

                  <li className={Resource.menu103 == 'resource-103' ? "" : "d-none"} >
                    <a hoverClass={Resource.menu103 == 'resource-103' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertObservation/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertObservation"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertObservation/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertObservation")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Alert_Observation"]}</a>
                  </li>
                  <li className={Resource.menu183 == 'resource-183' ? "" : "d-none"} >
                    <a hoverClass={Resource.menu183 == 'resource-183' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertsReportForm/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertsReportForm"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertsReportForm/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AlertsReportForm")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />Alerts Report</a>
                  </li>
                </ul>
              </li>
              {/* Deforestation Watch  */}
              {/* Nursery */}
              <li id='li_Nursery' className={Resource.menu48 == 'resource-48' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="nursery" />
                    <span className="link_name">{dic_lng["Nursery"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.nursery ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('nursery')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.nursery ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Nursery"]}
                    </a>
                  </li>
                  <li className={Resource.menu49 == 'resource-49' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu49 == 'resource-49' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Nursery/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Nursery"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Nursery/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Nursery")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Nursery"]}</a>
                  </li>
                  <li className={Resource.menu164 == 'resource-164' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu164 == 'resource-164' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/NurseryTarget/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/NurseryTarget"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/NurseryTarget/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/NurseryTarget")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Target_For_Nursery"]}</a>
                  </li>
                  <li className={Resource.menu50 == 'resource-50' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu50 == 'resource-50' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/WorkProgress/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/WorkProgress"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/WorkProgress/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/WorkProgress")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["ProgressofWork"]}</a>
                  </li>
                  <li className={Resource.menu51 == 'resource-51' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu51 == 'resource-51' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/StockDetails/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/StockDetails"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/StockDetails/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/StockDetails")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["StockDetails"]}</a>
                  </li>
                </ul>
              </li>
              {/* Nursery */}
              {/* Training */}
              <li id='li_Training' className={Resource.menu18 == 'resource-18' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="training" />
                    <span className="link_name">{dic_lng["Training"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.Training ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('Training')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.Training ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Training"]}
                    </a>
                  </li>
                  <li className={Resource.menu19 == 'resource-19' ? "nav-item" : "nav-item d-none"}>
                    <a hoverClass={Resource.menu19 == 'resource-19' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Training/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Training"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Training/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Training")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Training"]}</a>
                  </li>
                  <li className={Resource.menu20 == 'resource-20' ? "nav-item" : "nav-item d-none"}>
                    <a hoverClass={Resource.menu20 == 'resource-20' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingSyllabus/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingSyllabus"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingSyllabus/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingSyllabus")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Syllabus"]}</a>
                  </li>
                  <li className={Resource.menu21 == 'resource-21' ? "nav-item" : "nav-item d-none"}>
                    <a hoverClass={Resource.menu21 == 'resource-21' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingBatch/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingBatch"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingBatch/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingBatch")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["batch"]}</a>
                  </li>
                  <li className={Resource.menu22 == 'resource-22' ? "nav-item" : "nav-item d-none"}>
                    <a hoverClass={Resource.menu22 == 'resource-22' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Facilitators/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Facilitators"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Facilitators/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Facilitators")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Facilitators"]}</a>
                  </li>
                  <li className={Resource.menu23 == 'resource-23' ? "nav-item" : "nav-item d-none"}>
                    <a hoverClass={Resource.menu23 == 'resource-23' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingCalender/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingCalender"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingCalender/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingCalender")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Training_Calender"]}</a>
                  </li>
                  <li className={Resource.menu24 == 'resource-24' ? "nav-item" : "nav-item d-none"}>
                    <a hoverClass={Resource.menu24 == 'resource-24' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingFeedback/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingFeedback"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingFeedback/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TrainingFeedback")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["TrainingFeedback"]}</a>
                  </li>
                </ul>
              </li>
              {/* Training */}
              {/* Encroachment  */}
              {/* <li id='li_Encroachment' className={Resource.menu62 == 'resource-62' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="encroachment" />
                    <span className="link_name">{dic_lng["Encroachment"]}</span>
                    <i
                    className={`bx bxs-chevron-down arrow ${menuState.Encroachment ? 'rotate' : ''
                      }`}
                    onClick={() => toggleMenu('Encroachment')}
                  />
                  </a>
                  
                </div>
                <ul className={`sub-menu ${menuState.Encroachment ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Encroachment"]}
                    </a>
                  </li>
                  <li className={Resource.menu63 == 'resource-63' ? "" : "d-none"}>
                    <a hoverClass = {Resource.menu63 == 'resource-63' ? "" : "d-none"}
                    url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/RegisterEncroachment/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/RegisterEncroachment"}
                    onClick={() => (location.pathname.includes('/as')) ?
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/RegisterEncroachment/as") :
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/RegisterEncroachment")}>
                    <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["RegisterEncroachment"]}</a>
                  </li>
                  <li className={Resource.menu64 == 'resource-64' ? "" : "d-none"}>
                    <a hoverClass = {Resource.menu64 == 'resource-64' ? "" : "d-none"}
                    url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/EncroachmentAdmin/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/EncroachmentAdmin"}
                    onClick={() => (location.pathname.includes('/as')) ?
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EncroachmentAdmin/as") :
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/EncroachmentAdmin")}>
                    <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["EncroachmentAdmin"]}</a>
                  </li>
                </ul>
              </li> */}
              {/* Encroachment  */}
              {/* Vehicle Management */}
              <li id='li_Vehicle' className={Resource.menu32 == 'resource-32' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="vehicle" />
                    <span className="link_name">{dic_lng["Vehicle_Management"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.Vehicle_Management ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('Vehicle_Management')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.Vehicle_Management ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Vehicle_Management"]}
                    </a>
                  </li>
                  <li className={Resource.menu33 == 'resource-33' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu33 == 'resource-33' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Vehicle/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Vehicle"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Vehicle/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Vehicle")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Vehicle_Inventory"]}</a>
                  </li>
                  <li className={Resource.menu34 == 'resource-34' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu34 == 'resource-34' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleAllotment/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleAllotment"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleAllotment/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleAllotment")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Vehicle_Allotment"]}</a>
                  </li>
                  <li className={Resource.menu45 == 'resource-45' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu45 == 'resource-45' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleMaintainance/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleMaintainance"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleMaintainance/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/VehicleMaintainance")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Vehicle_Maintenance"]}</a>
                  </li>
                </ul>
              </li>
              {/* Vehicle Management */}

              {/* <li>
            <a href="#">
              <i className="bx bx-pie-chart-alt-2" />
              <span className="link_name">Analytics</span>
            </a>
            <ul className="sub-menu blank">
              <li>
                <a className="link_name" href="#">
                  Analytics
                </a>
              </li>
            </ul>
          </li> */}
              {/* Court Cases  */}
              <li id='li_courtCase' className={Resource.menu105 == 'resource-105' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="courtCase" />
                    <span className="link_name">{dic_lng["CourtCase"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.CourtCase ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('CourtCase')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.CourtCase ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["CourtCase"]}
                    </a>
                  </li>
                  <li className={Resource.menu106 == 'resource-106' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu106 == 'resource-106' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/CourtCase/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/CourtCase"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/CourtCase/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/CourtCase")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["CourtCase"]}</a>
                  </li>
                </ul>
              </li>
              {/* Court Cases  */}
              {/* FRA */}
              <li id='li_FRA' className={Resource.menu35 == 'resource-35' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="fra" />
                    <span className="link_name">{dic_lng["FRA"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.FRA ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('FRA')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.FRA ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["FRA"]}
                    </a>
                  </li>
                  <li className={Resource.menu36 == 'resource-36' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu36 == 'resource-36' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRA/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRA"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRA/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/FRA")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["FRA_Claim"]}</a>
                  </li>
                </ul>
              </li>
              {/* FRA */}
              {/* Asset Management  */}
              <li id='li_AssetManagement' className={Resource.menu65 == 'resource-65' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="assetManagement" />
                    <span className="link_name">{dic_lng["Asset_Management"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.Asset_Management ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('Asset_Management')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.Asset_Management ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Asset_Management"]}
                    </a>
                  </li>
                  <li className={Resource.menu66 == 'resource-66' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu66 == 'resource-66' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AssetManagement/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/AssetManagement"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AssetManagement/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/AssetManagement")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Asset_Management"]}</a>
                  </li>
                </ul>
              </li>
              {/* Asset Management  */}
              {/* Digital Library */}
              <li id='li_DigitalLibrary' className={Resource.menu59 == 'resource-59' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="digitalLibrary" />
                    <span className="link_name">{dic_lng["Digital_Library"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.Digital_Library ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('Digital_Library')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.Digital_Library ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Digital_Library"]}
                    </a>
                  </li>
                  <li className={Resource.menu59 == 'resource-59' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu59 == 'resource-59' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/DigitalLibrary/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/DigitalLibrary"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/DigitalLibrary/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/DigitalLibrary")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Digital_Library"]}</a>
                  </li>
                </ul>
              </li>
              {/* Digital Library */}

              {/* ForestResourceAssessment */}
              <li id='li_ForestResourceAssessment' className={Resource.menu176 == 'resource-176' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="assign-plot" />
                    <span className="link_name">Plot Assignment</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.ForestResourceAssessment ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('ForestResourceAssessment')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.ForestResourceAssessment ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      Plot Assignment
                    </a>
                  </li>
                  <li className={Resource.menu178 == 'resource-178' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu178 == 'resource-178' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ListPlotData/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ListPlotData"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ListPlotData/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ListPlotData")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" /> Plot List</a>
                  </li>
                  <li className={Resource.menu177 == 'resource-177' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu177 == 'resource-177' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ForestResourceAssessment/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/ForestResourceAssessment"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ForestResourceAssessment/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ForestResourceAssessment")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" /> Plot Assignment</a>
                  </li>
                </ul>
              </li>
              {/* ForestResourceAssessment */}
              {/* Patrolling */}
              <li id='li_Patrolling' className={Resource.menu180 == 'resource-180' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="patrolling" />
                    <span className="link_name">Patrolling</span>
                    <i className={`bx bxs-chevron-down arrow ${menuState.Patrolling ? 'rotate' : ''}`}
                      onClick={() => toggleMenu('Patrolling')}
                    />
                  </a>
                </div>
                <ul className={`sub-menu ${menuState.li_Patrolling ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      Patrolling
                    </a>
                  </li>
                  <li className={Resource.menu181 == 'resource-181' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu181 == 'resource-181' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/patrol/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/patrol"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/patrol/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/patrol")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />Patrolling</a>
                  </li>
                </ul>
              </li>
              {/* Patrolling */}
              {/* Revenue  */}
              <li id='li_Revenue' className={Resource.menu138 == 'resource-138' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="revenue" />
                    <span className="link_name">{dic_lng["Revenue"]}</span>
                    <i
                      className={`bx bxs-chevron-down arrow ${menuState.Revenue ? 'rotate' : ''
                        }`}
                      onClick={() => toggleMenu('Revenue')}
                    />
                  </a>

                </div>
                <ul className={`sub-menu ${menuState.Revenue ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Revenue"]}
                    </a>
                  </li>
                  <li className={Resource.menu139 == 'resource-139' ? "" : "d-none"}>
                    <a hoverClass={Resource.menu139 == 'resource-139' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Revenue/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/Revenue"}
                      onClick={() => (location.pathname.includes('/as')) ?
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Revenue/as") :
                        navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Revenue")}>
                      <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Revenue"]}</a>
                  </li>
                </ul>
              </li>
              {/* Revenue  */}

              {/* TOF */}
              {/* <li id='li_TOF' className={Resource.menu4 == 'resource-4' ? "nav-item" : "nav-item d-none"} >
                <div className="iocn-link">
                  <a href="javascript:void(0)">
                    <i className="tof-icon" />
                    <span className="link_name">{dic_lng["Tree_Out_Forest"]}</span>
                    <i
                    className={`bx bxs-chevron-down arrow ${menuState.Tree_Out_Forest || menuState.Tree_Out_Forest_Rotate ? 'rotate' : ''
                      }`}
                    onClick={() => toggleMenu('Tree_Out_Forest')}
                  />
                  </a>
                 
                </div>
                <ul className={`sub-menu ${menuState.Tree_Out_Forest ? 'showMenu' : ''}`}>
                  <li>
                    <a className="link_name" href="javascript:void(0)">
                      {dic_lng["Tree_Out_Forest"]}
                    </a>
                  </li>
                  <li className={Resource.menu5 == 'resource-5' ? "" : "d-none"}>
                    {currentUser.role_en == "DFO" ? (
                      <a hoverClass = {Resource.menu5 == 'resource-5' ? "" : "d-none"}
                      url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard_staff/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard_staff"}
                        id="a_tof_ud" onClick={() => (location.pathname.includes('/as')) ? navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard_staff/as") : navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard_staff")}>
                        <span><i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Dashboard"]}</span>
                      </a>
                    ) : (
                      <a  hoverClass = {Resource.menu5 == 'resource-5' ? "" : "d-none"}
                      id="a_tof_ud" url={(location.pathname.includes('/as')) ?
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard/as" :
                        globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard"}
                        onClick={() => (location.pathname.includes('/as')) ? navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard/as") : navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TOF_Dashboard")}>
                        <span><i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Dashboard"]}</span>
                      </a>
                    )}
                  </li>
                  <li className={Resource.menu7 == 'resource-7' ? "" : "d-none"}>
                    <a  hoverClass = {Resource.menu7 == 'resource-7' ? "" : "d-none"}
                    url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/Applications/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/Applications"}
                    onClick={() => (location.pathname.includes('/as')) ?
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Applications/as") :
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/Applications")}>
                    <i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Applications"]}</a>
                  </li>
                  <li className={Resource.menu8 == 'resource-8' ? "" : "d-none"}>
                    <a  hoverClass = {Resource.menu8 == 'resource-8' ? "" : "d-none"}
                    url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationsTF/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationsTF"}
                    onClick={() => (location.pathname.includes('/as')) ?
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationsTF/as") :
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationsTF")}>
                      <span><i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["TF_Applications"]}</span>
                    </a>
                  </li>
                  <li className={Resource.menu9 == 'resource-9' ? "" : "d-none"}>
                    <a  hoverClass = {Resource.menu9 == 'resource-9' ? "" : "d-none"}
                    url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationReg/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationReg"}
                    onClick={() => (location.pathname.includes('/as')) ?
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationReg/as") :
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/ApplicationReg")}>
                    <span><i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Plantation_Reg"]}</span>
                    </a>
                  </li>
                  <li className={Resource.menu10 == 'resource-10' ? "" : "d-none"}>
                    <a  hoverClass = {Resource.menu10 == 'resource-10' ? "" : "d-none"}
                    url={(location.pathname.includes('/as')) ?
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/TreeFelling/as" :
                    globalThis.config.Settings.ApiConfiguration.BaseURL + "/TreeFelling"}
                    onClick={() => (location.pathname.includes('/as')) ?
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TreeFelling/as") :
                    navigate(globalThis.config.Settings.ApiConfiguration.BaseURL + "/TreeFelling")}>
                    <span><i className="bi bi-arrow-right-square sub_menu_arrow mr-2" />{dic_lng["Tree_Felling"]}</span>
                    </a>
                  </li>
                </ul>
              </li> */}
              {/* TOF */}
            </ul>
          </div>
        </div>

        <div ref={htmlRef} className="floating-submenu" id="floatingSubmenu" dangerouslySetInnerHTML={{ __html: sub_menu_html }} >

        </div>
      </>
    </>
  )
}
export default UserSidebar;